module.exports = __webpack_public_path__ + "img/survey.f96bb7d8.svg";